// extracted by mini-css-extract-plugin
export default {"item":"TabPanels_item__MYbdO","active":"TabPanels_active__8FQIh"};